import React, { useEffect, useRef, useState } from "react";
import Layout from "../../../layout/Layout";
import stephanieUnfamiliarAudio from "../quotes/eksamen-var-ikke-så-uvant-stephanie.mp3";
import mathildeExamTrainingAudio from "../quotes/hvordan-var-det-så-at-bruge-mathilde.mp3";
import mathildeTenMinutesAudio from "../quotes/hvordan-tror-du-mathilde.mp3";
import magnusAudio from "../quotes/så-vil-du-anbefale-magnus.mp3";
import nikolajAudio from "../quotes/jeg-tænker-helt-klart-nikolaj.mp3";
import stephanieAudio from "../quotes/vil-du-anbefale-det-her-til-andre-studerende-stephanie.mp3";

const STUDENT_QUOTES = [
  {
    id: 1,
    name: "Stephanie",
    quote: `
"Det var det med, at det ikke var så uvant. Fordi tit, når man kommer ind til eksamen, man aner jo ikke, hvad man skal forvente overhovedet. Og her havde jeg fået et smagsprøv for det i trygge omgivelser, hvor man ikke skal præstere på samme måde. Så det der med, at man har prøvet det før, at nu har du de her 10 minutter, nu er det de her opgaver, du skal nå igennem. Det gjorde bare noget inde til eksamen. Jeg havde også snakket højt om det, jeg skriver. For tit, når man sidder og skriver, du siger det jo ikke højt. Du sidder bare og koder det og her blev man også trænet i, at sige det højt. Som man skulle inde til eksamen. Og det havde jeg jo aldrig gjort, hvis der ikke havde været den her. Der havde jeg ikke siddet og sagt koden højt for mig."
    `,
    audio: stephanieUnfamiliarAudio,
  },
  {
    id: 4,
    name: "Magnus",
    quote: `
"Så vil du anbefale det her til andre studerende, og måske også sådan, hvorfor vil du anbefale det til andre studerende?"

"Jeg vil helt klart anbefale det. Og det vil jeg gøre, fordi som jeg selv, så bliver jeg ekstremt nervøs op til de her eksaminer. Så det har hjulpet mig i forhold til at have en idé om, hvad er det egentlig, jeg går ind til, og hvad kan jeg forvente? Og i og med at jeg har brugt den og gået igennem alle emnerne på mineksamen og lavet en hel masse opgaver, så føler jeg mig mere rustet til at gå til den rigtige eksamen ved at have lavet de her opgaver."
    `,
    audio: magnusAudio,
  },
  {
    id: 3,
    name: "Mathilde",
    quote: `
"Men hvordan var det så at bruge mineksamen for forberedelse til din eksamen? Sådan helt overordnet, hvordan synes du det fungerede?"

"Altså jeg synes det var vildt smart faktisk. Jeg synes det var rigtig smart. Det var en ret god læring at man skulle tale til den."

"Kan du sætte flere ord på det? Hvad var god læring ved det?"

"Jamen at man ligesom fik øvet sig i at sætte ord på det. Øve sig i at sige noget mundtligt, men også hele den der eksamenssituation  at få øvet den. Fordi at man som studerende ikke altid lige ved hvordan det kommer til at være. At man kan simulere en eksamenssituation er ret fedt med den."
    `,
    audio: mathildeExamTrainingAudio,
  },
  {
    id: 5,
    name: "Nikolaj",
    quote:
    `
    "Hva tænker du egentlig?"

      "Jeg tænker helt klart, den har hjulpet mig positivt med det, fordi jeg tror meget af det basale syntax, som vi har lært igennem undervisning i hvert fald, den har helt klart fået mere til at sidde fast i mine fingre, og i hovedet ved hjælp af mineksamen. At repetitionen og opgaverne går lidt igen og der er lidt variation. Så har det hjulpet mig rigtig meget til at huske getElementById det ved jeg hvordan jeg henter i javascript"`,
    audio: nikolajAudio,
  },
  {
    id: 2,
    name: "Stephanie",
    quote: `
"Vil du anbefale det her til andre studerende, og hvis ja, hvorfor?"

"Ja, det vil jeg, fordi man får virkelig en bedre forståelse i praksis. Det gør også noget for ens nervøsitet i en eksamen. Fordi jeg føler mig bedre klædt på til at jeg jeg vidste okay, min computer skal kobles til skærmen, hvilket godt kan være angstprovokerende, men jeg havde ligesom prøvet det med AI. Det der med faktisk at sidde og gøre det. Det var så ikke en person, men der var nogen der sad og bedømte og kiggede på mit arbejde. Så det ikke kun var ens eget hoved"
    `,
    audio: stephanieAudio,
  },
  {
    id: 6,
    name: "Mathilde",
    quote: `
"Hvordan tror du det har påvirket dig, det at du havde brugt noget tid med mineksamen?"

"Jeg følte at jeg havde en idé om hvor lang tid 10 minutter var. Og det er jo ikke særlig lang tid."
    `,
    audio: mathildeTenMinutesAudio,
  },
];

const LandingPage: React.FC = () => {
  const [playingId, setPlayingId] = useState<number | null>(null);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const handlePlayAudio = (quote: (typeof STUDENT_QUOTES)[0]) => {
    if (playingId === quote.id) {
      audioRef.current?.pause();
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
      }
      setPlayingId(null);
      return;
    }
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    const audio = new Audio(quote.audio);
    audio.onended = () => setPlayingId(null);
    audioRef.current = audio;
    audio.play().catch(() => setPlayingId(null));
    setPlayingId(quote.id);
  };

  useEffect(() => {
    return () => {
      audioRef.current?.pause();
      audioRef.current = null;
    };
  }, []);

  useEffect(() => {
    const fadeElements = document.querySelectorAll(".fade-in");

    const fadeInOnScroll = () => {
      fadeElements.forEach((el) => {
        const elementTop = el.getBoundingClientRect().top;
        if (elementTop < window.innerHeight - 100) {
          el.classList.add("visible");
        }
      });
    };

    window.addEventListener("scroll", fadeInOnScroll);
    fadeInOnScroll(); // Initial check

    return () => window.removeEventListener("scroll", fadeInOnScroll);
  }, []);

  return (
    <Layout>
      <div className="bg-white">
        {/* Hero Section */}
        <section className="relative bg-blue-800 py-16 md:py-20">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="md:flex md:items-center md:justify-between">
              <div className="md:w-1/2 md:pr-10">
                <h1 className="text-3xl md:text-5xl font-bold text-white">
                  Eksamenstræning der virker
                </h1>
                <p className="mt-4 text-xl text-blue-100">
                  Træn din mundtlige eksamen med en AI du kan snakke med
                </p>
              </div>
              <div className="mt-10 md:mt-0 md:w-1/2">
                <div className="relative mx-auto max-w-md">
                  <div className="bg-white rounded-lg shadow-lg p-6">
                    <div className="flex items-center space-x-4 mb-4">
                      <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                        <svg
                          className="w-6 h-6 text-blue-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                          />
                        </svg>
                      </div>
                      <div>
                        <p className="font-medium text-gray-900">
                          Algoritmer og Datastrukturer
                        </p>
                        <p className="text-sm text-gray-500">10 min</p>
                      </div>
                    </div>
                    <div className="border-t border-gray-200 pt-4 mt-4">
                      <div className="space-y-3">
                        <div className="flex items-start">
                          <div className="flex-shrink-0">
                            <svg
                              className="h-5 w-5 text-green-500"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                          </div>
                          <p className="ml-3 text-sm text-gray-700">
                            Algoritmer og datastrukturer
                          </p>
                        </div>
                        <div className="flex items-start">
                          <div className="flex-shrink-0">
                            <svg
                              className="h-5 w-5 text-green-500"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                          </div>
                          <p className="ml-3 text-sm text-gray-700">Big O</p>
                        </div>
                        <div className="flex items-start">
                          <div className="flex-shrink-0">
                            <svg
                              className="h-5 w-5 text-green-500"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                          </div>
                          <p className="ml-3 text-sm text-gray-700">
                            Sorteringsalgoritmer
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* <div className="mt-6">
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div className="bg-blue-600 h-2 rounded-full" style={{ width: '75%' }}></div>
                      </div>
                      <p className="text-right text-xs text-gray-500 mt-1">75% gennemført</p>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Video sektion */}
        <section className="py-12 md:py-16 bg-white fade-in">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                Se hvordan det fungerer
              </h2>
              <p className="mt-2 text-lg text-gray-600">
                En kort gennemgang af eksamenstræningen i praksis
              </p>
            </div>
            <div className="overflow-hidden rounded-2xl shadow-xl ring-1 ring-gray-200">
              <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
                <iframe
                  className="absolute inset-0 h-full w-full"
                  src="https://www.youtube.com/embed/YcttH4uolJU?si=NhvCz6BRkIaCMqnh"
                  title="Exam simulator demonstration"
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
                
              </div>
            </div>
          </div>
        </section>

        {/* Elevcitater sektion */}
        <section className="py-12 md:py-16 bg-gray-50 fade-in">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                Hvad siger de studerende om at bruge MinEksamen?
              </h2>
            </div>
            <div className="student-quotes-grid">
              {STUDENT_QUOTES.map((q) => (
                <div
                  key={q.id}
                  className="student-quote-card bg-blue-600 rounded-2xl shadow-lg p-6 flex flex-col justify-between fade-in"
                >
                  {/* Top row: quote icon + play button */}
                  <div className="flex items-start justify-between">
                    <svg
                      className="h-8 w-8 text-blue-400 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 32 32"
                    >
                      <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                    </svg>
                    <button
                      onClick={() => handlePlayAudio(q)}
                      aria-label={
                        playingId === q.id ? "Pause audio" : "Afspil audio"
                      }
                      className="flex-shrink-0 w-10 h-10 rounded-full bg-white/20 hover:bg-white/30 active:scale-95 transition-all flex items-center justify-center"
                    >
                      {playingId === q.id ? (
                        <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                        </svg>
                      ) : (
                        <svg className="w-4 h-4 text-white translate-x-0.5" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      )}
                    </button>
                  </div>

                  <div className="mt-4 flex-1">
                    <p className="student-quote-copy text-white text-sm leading-relaxed">
                      {q.quote.trim()}
                    </p>
                  </div>

                  {/* Name */}
                  <p className="mt-5 font-semibold text-white text-sm">
                    {q.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Fordele sektion */}
        <section className="py-12 md:py-16 bg-gray-50">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                Træn som til den rigtige eksamen
              </h2>
              <p className="mt-2 text-lg text-gray-600">
                Forbered dig optimalt med realistiske eksamensforhold
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white p-6 rounded-lg shadow-md fade-in">
                <div className="w-12 h-12 rounded-md bg-blue-100 flex items-center justify-center mb-4">
                  <svg
                    className="w-6 h-6 text-blue-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                    />
                  </svg>
                </div>
                <h3 className="font-semibold text-lg text-gray-900">
                  Snak som i den rigtige eksamen
                </h3>
                <p className="mt-2 text-gray-600">
                  Del din skærm og gå til eksamen ved en AI censor der både
                  forstår og udfordrer dig
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md fade-in">
                <div className="w-12 h-12 rounded-md bg-blue-100 flex items-center justify-center mb-4">
                  <svg
                    className="w-6 h-6 text-blue-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                    />
                  </svg>
                </div>
                <h3 className="font-semibold text-lg text-gray-900">
                  Tilpasset dit pensum
                </h3>
                <p className="mt-2 text-gray-600">
                  Din underviser har oprettet en eksamen der minder så meget om
                  den rigtige eksamen som muligt
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md fade-in">
                <div className="w-12 h-12 rounded-md bg-blue-100 flex items-center justify-center mb-4">
                  <svg
                    className="w-6 h-6 text-blue-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h3 className="font-semibold text-lg text-gray-900">
                  Detaljeret feedback og karakter
                </h3>
                <p className="mt-2 text-gray-600">
                  Få personlig feedback og en karakter og dermed lær af dine
                  fejl for at forbedre din præstation.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Citat sektion
        <section className="py-12 md:py-16 fade-in">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <svg
              className="h-12 w-12 text-gray-300 mx-auto mb-4"
              fill="currentColor"
              viewBox="0 0 32 32"
            >
              <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
            </svg>
            <p className="text-xl md:text-2xl font-medium text-gray-900">
              "Man kan jo bare snakke med AI'en! Det føles virkelig som at tage
              den rigtige eksamen, men i trygge rammer, hvor ingen dømmer mig"
            </p>
            <div className="mt-6">
              <p className="font-medium text-gray-900">Mette Andersen</p>
              <p className="text-gray-600">
                Datalogistuderende, Københavns Universitet
              </p>
            </div>
          </div>
        </section>
         */}
      </div>

      {/* CSS for animations */}
      <style>
        {`
          .student-quotes-grid {
            display: grid;
            gap: 1.5rem;
          }

          .student-quote-copy {
            white-space: pre-line;
          }

          @media (min-width: 640px) {
            .student-quotes-grid {
              grid-template-columns: repeat(2, minmax(0, 1fr));
            }
          }

          @media (min-width: 1024px) {
            .student-quotes-grid {
              grid-template-columns: repeat(6, minmax(0, 1fr));
            }

            .student-quote-card {
              grid-column: span 2;
            }

            .student-quote-card:last-child:nth-child(3n + 1) {
              grid-column: span 6;
            }

            .student-quote-card:nth-last-child(2):nth-child(3n + 1),
            .student-quote-card:last-child:nth-child(3n + 2) {
              grid-column: span 3;
            }
          }

          .fade-in {
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 0.6s ease, transform 0.6s ease;
          }
          
          .fade-in.visible {
            opacity: 1;
            transform: translateY(0);
          }
        `}
      </style>
    </Layout>
  );
};

export default LandingPage;
